import { BLACK_DEAL_TAGS, NUMBER_3 } from '~shared/constants';
import { Offer } from '~app/modules/product/models';
import { OfferLabels } from '~app/modules/product/enums/offer-labels.enum';

export namespace ProductUtil {
  export function isBlackDealProduct(tags: string[]) {
    return tags?.some(item => BLACK_DEAL_TAGS.includes(item));
  }

  export function isLimitedStock(quantity: number) {
    return quantity <= NUMBER_3;
  }

  export function hasOfferPromotion(offer: Offer): boolean {
    return (offer && offer.labels) && offer.labels.includes(OfferLabels.Promotion);
  }
}
